import { OperationEfficiencyModel } from "./operation-efficiency.model";


export class LineOperationEfficiencyModel {
    lineId: string;
    lineDesc: string;
    operationEfficiency: OperationEfficiencyModel[];

    constructor(lineId: string,
        lineDesc: string,
        operationEfficiency: OperationEfficiencyModel[]) {
            this.lineId = lineId;
            this.lineDesc = lineDesc;
            this.operationEfficiency = operationEfficiency;
    }
}